import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import tabTitle from "./mixins/tabTitle";
import Clipboard from "v-clipboard";

Vue.config.productionTip = false;

//Cookies
Vue.use(require("vue-cookies"));
Vue.$cookies.config("604800s");

//Mixins
Vue.mixin(tabTitle);

//V-Clipboard
Vue.use(Clipboard);

//Global Vars
Vue.prototype.$siteUrl = "https://listify.live";
Vue.prototype.$apiUrl = "https://api.listify.live";
Vue.prototype.$authUrl =
  "https://accounts.spotify.com/authorize?client_id=0d06408d36494c1ea7feab76064610bb&response_type=code&redirect_uri=https%3A%2F%2Flistify.live%2Fauth&scope=playlist-modify-public%20playlist-modify-private%20playlist-read-private%20user-read-private%20user-top-read";
if (!Vue.$cookies.get("authToken")) {
  Vue.prototype.$authUrl =
    "https://accounts.spotify.com/authorize?client_id=0d06408d36494c1ea7feab76064610bb&response_type=code&redirect_uri=https%3A%2F%2Flistify.live%2Fauth&scope=playlist-modify-public%20playlist-modify-private%20playlist-read-private%20user-read-private%20user-top-read&show_dialog=true";
}
Vue.prototype.$dev = Vue.config.devtools;

if (Vue.prototype.$dev) {
  Vue.prototype.$siteUrl = "http://localhost:8080";
  Vue.prototype.$authUrl =
    "https://accounts.spotify.com/authorize?client_id=0d06408d36494c1ea7feab76064610bb&response_type=code&redirect_uri=http%3A%2F%2Flocalhost:8080%2Fauth&scope=playlist-modify-public%20playlist-modify-private%20playlist-read-private%20user-read-private%20user-top-read";
  if (!Vue.$cookies.get("authToken")) {
    Vue.prototype.$authUrl =
      "https://accounts.spotify.com/authorize?client_id=0d06408d36494c1ea7feab76064610bb&response_type=code&redirect_uri=http%3A%2F%2Flocalhost:8080%2Fauth&scope=playlist-modify-public%20playlist-modify-private%20playlist-read-private%20user-read-private%20user-top-read&show_dialog=true";
  }
  Vue.prototype.$apiUrl = "http://127.0.0.1:8787";
}

const store = Vue.observable({
  notifications: [],
  addNotification(notification) {
    store.notifications.push(notification);
  },
  getAndRemoveNotification() {
    return store.notifications.shift();
  },
  topArtists: {},
  userProfile: {},
  userPlaylists: [],
  listify: null,
  listifyInfo: null,
  userRef: null,
});

Vue.prototype.$globalState = store;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
